import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import styled from 'styled-components'

import TogglePlayButton from '../TogglePlayButton'

import { progressiveBreakpoints } from '../../constants/theme'

import animationData from './animationData.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const DiscountAnimationWrapper = styled.div`
  position: relative;
  width: inherit;
  margin-bottom: ${(props) => (props.noSpacing ? '0' : '34px')};

  @media ${progressiveBreakpoints.desktopSmall} {
    width: auto;
    margin-bottom: 0;
    padding-left: ${(props) => (props.noSpacing ? '0' : '34px')};
  }
`

const DiscountAnimation = ({ size, noSpacing }) => {
  const [isPaused, togglePlay] = useState(false)

  const handleToggle = () => togglePlay(!isPaused)

  return (
    <DiscountAnimationWrapper
      data-testid="get-money-back-animation"
      noSpacing={noSpacing}
    >
      <Lottie
        options={defaultOptions}
        height={size || 280}
        width={size || 280}
        isPaused={isPaused}
      />
      <TogglePlayButton isPaused={isPaused} onHandleToggle={handleToggle} />
    </DiscountAnimationWrapper>
  )
}

DiscountAnimation.propTypes = {
  size: PropTypes.number,
  noSpacing: PropTypes.bool,
}

export default DiscountAnimation
